import {gql} from '@apollo/client'

export const CREATE_ORDER_EDIT = gql`
  mutation CreateEditOrder($orderId: UUID!) {
    createEditOrder(input: {pOrderId: $orderId}) {
      clientMutationId
      orderEdits {
        id: orderId
        orderEditId: id
        note
        shippingAddressId
        orderDeliveryMethod
        subtotalPrice
        shippingPrice
        totalDiscounts
        wineClubDiscounts
        totalTax
        totalPrice
        shippingRateId
        paymentMethodId
        billingAddressId
        notes
        salesTax
        crv
        isTaxRemoved
        isAutoDiscountRemoved
        isWineMackerChoiceDiscountDisabled
        discounts: appliedDiscounts {
          nodes {
            id
            amount
            code
            isPromoCode
            discountCodeId
            isShipping
            isWineClub
            name
            customDiscountPercentage
            isDiscountOverride
          }
        }
        shippingRate {
          id
          title
          serviceId
          price
          title
          serviceType
          carrierType
          originalPrice
          discount
          handlingFee
          providerShippingPrice
        }
        paymentMethod {
          id
          card {
            brand
            last4
            expYear
            expMonth
          }
          isPrimary
          address {
            id
            firstName
            lastName
            addressLine2
            addressLine1
            city
            country {
              code
            }
            state {
              code
              name
            }
            zipCode
          }
        }
        shippingAddress {
          id
          firstName
          lastName
          addressLine1
          addressLine2
          city
          state {
            code
            name
          }
          country {
            code
          }
          zipCode
        }
        billingAddress {
          id
          firstName
          lastName
          addressLine1
          addressLine2
          city
          state {
            code
            name
          }
          country {
            code
          }
          zipCode
        }
        orderItems: orderEditItems {
          nodes {
            id
            price
            quantity
            orderEditId
            variantId
            orderItemId
            available
            variant {
              available
              id
              name
              price
              discountPrice
              weight {
                value
                units
              }
              inventoryItem {
                canAllowNegativeInventory
              }
              product {
                id
                name
                imageSrc
              }
            }
          }
        }
        order {
          id
          name
          email
          phone
          orderNumber
          orderType
          orderDeliveryMethod
          fulfillmentStatus
          financialStatus
          totalPrice
          subtotalPrice
          createdAt
          shippingPrice
          totalDiscounts
          wineClubDiscounts
          totalTax
          taxId
          customerId
          shippingRateId
          discounts
          note
          notes
          fulfillmentLocationId
          shippingAddressId
          isCrvEnabled
          giftMessage
          paymentType
          customer {
            id
            firstName
            lastName
            email
            phone
            hasWineClub
            shippingPreferenceCompany
          }
          billingAddress {
            id
            firstName
            lastName
            addressLine1
            addressLine2
            city
            state {
              code
              name
            }
            country {
              code
            }
            zipCode
          }
          shippingAddress {
            id
            firstName
            lastName
            addressLine1
            addressLine2
            city
            state {
              code
              name
            }
            country {
              code
            }
            zipCode
          }
          orderAddressProfiles {
            nodes {
              id
              firstName
              lastName
              phone
              addressLine1
              addressLine2
              city
              addressType
              state {
                code
                name
              }
              country {
                code
              }
              zipCode
            }
          }
          orderItems {
            nodes {
              id
              fulfillableQuantity
              fulfilledQuantity
              refundedQuantity
              price
              quantity
              variantId
              variant {
                available
                id
                name
                sku
                discountPrice
                weight {
                  value
                  units
                }
                product {
                  id
                  name
                  imageSrc
                }
              }
            }
          }
          fulfillments {
            nodes {
              id
              isPickup
              locationId
              fulfillmentShippingLabels {
                nodes {
                  url
                  graphicImage
                  encodedLabel
                  docType
                }
              }
              trackingUrl
              trackingCompanyName
              tracking {
                trackingNumber
                companyName
              }
              fulfillmentItems {
                nodes {
                  quantity
                  id
                  price
                  orderedQuantity
                  refundedQuantity
                  variant {
                    sku
                    name
                    product {
                      id
                      name
                      imageSrc
                    }
                  }
                }
              }
            }
          }
          orderHistories(orderBy: CREATED_AT_DESC, filter: {activity: {isNull: false}}) {
            nodes {
              orderEditId
              createdAt
              title: activity
              summary
              orderStatusSummary
              user: userByCreatedBy {
                firstName
                lastName
              }
              orderItems {
                nodes {
                  originalQuantity
                  orderItemId
                  quantity
                  price
                  variant {
                    name
                    product {
                      id
                      name
                      imageSrc
                    }
                  }
                }
              }
              refundItems {
                nodes {
                  quantity
                  price
                  variant {
                    name
                    product {
                      id
                      name
                      imageSrc
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const CREATE_ORDER_REFUND = gql`
  mutation CreateRefundOrder($orderId: UUID!, $fulfillmentId: UUID!) {
    createRefundOrder(input: {pOrderId: $orderId, pFulfillmentId: $fulfillmentId}) {
      orderEdits {
        id: orderId
        orderEditId: id
        note
        subtotalPrice
        shippingPrice
        totalDiscounts
        wineClubDiscounts
        totalTax
        totalPrice
        restockLocationId
        freightSalesTax
        discounts: appliedDiscounts {
          nodes {
            id
            amount
            code
            isPromoCode
            discountCodeId
            isShipping
            isWineClub
            name
            customDiscountPercentage
          }
        }
        orderItems: orderEditItems {
          nodes {
            id
            price
            quantity
            orderEditId
            variantId
            orderItemId
            salesTax
            variant {
              available
              id
              name
              price
              discountPrice
              weight {
                value
                units
              }
              product {
                id
                name
                imageSrc
              }
            }
          }
        }
        order {
          id
          name
          orderNumber
          orderType
          paymentType
          orderDeliveryMethod
          fulfillmentStatus
          financialStatus
          totalPrice
          subtotalPrice
          createdAt
          shippingPrice
          totalDiscounts
          wineClubDiscounts
          totalTax
          taxId
          customerId
          shippingRateId
          discounts
          note
          notes
          fulfillmentLocationId
          customer {
            id
          }
          paymentType
          paymentMethod {
            id
            card {
              brand
              last4
              expYear
              expMonth
            }
          }
        }
      }
      clientMutationId
    }
  }
`

export const REMOVE_ORDER_EDIT_DISCOUNT = gql`
  mutation RemoveOrderEditDiscount($discountCodeId: UUID!) {
    removeOrderEditDiscount(input: {pEditDiscountCodeId: $discountCodeId}) {
      clientMutationId
    }
  }
`

export const SAVE_ORDER_EDIT_DISCOUNT = gql`
  mutation SaveOrderEditDiscount($discount: SaveOrderEditDiscountInput!) {
    saveOrderEditDiscount(input: $discount) {
      clientMutationId
      discounts: orderEditDiscountTypes {
        amount
        code
        customDiscountPercentage
        discountCodeId
        id
        isFreeShipping
        isPromoCode
        isShipping
        isWineClub
        name
        isDiscountOverride
      }
    }
  }
`

export const UPDATE_ORDER_WITH_ITEMS = gql`
  mutation UpdateOrderEditWithItems($orderEdit: UpdateOrderEditWithItemsInput!) {
    updateOrderEditWithItems(input: $orderEdit) {
      clientMutationId
      orderEditItems {
        id
        variantId
      }
    }
  }
`

export const UPDATE_REFUND_ORDER_WITH_ITEMS = gql`
  mutation UpdateRefundOrderEditWithItems($orderRefund: UpdateRefundOrderEditWithItemsInput!) {
    updateRefundOrderEditWithItems(input: $orderRefund) {
      clientMutationId
    }
  }
`

export const UPDATE_EDIT_ORDER = gql`
  mutation UpdateEditOrder($orderEdit: OrderEditInput!) {
    updateEditOrder(input: {orderEdit: $orderEdit}) {
      clientMutationId
    }
  }
`

export const ORDER_EDIT_DISCOUNT_APPLY = gql`
  mutation orderEditDiscountCodeApply($discount: OrderEditDiscountCodeInput!) {
    orderEditDiscountCodeApply(input: $discount) {
      discounts
      errors
      status
      discountAmount
      shippingRate
    }
  }
`

export const ORDER_EDIT_WINE_CLUB_DISCOUNT_APPLY = gql`
  mutation orderEditAutoDiscountApply($discount: EditOrderDiscountInput!) {
    orderEditAutoDiscountApply(input: $discount) {
      discounts
      errors
      status
      discountAmount
      shippingRate
    }
  }
`

export const VALIDATE_ORDER_EDIT_DISCOUNT = gql`
  mutation validateOrderEditDiscount($discount: EditOrderDiscountInput!) {
    validateOrderEditDiscount(input: $discount) {
      discountAmount
      discounts
      errors
      status
      shippingRate
    }
  }
`

export const UPDATE_ORDER_EDIT = gql`
  mutation updateOrderEdit($id: UUID!, $order: OrderEditPatch!) {
    updateOrderEdit(input: {patch: $order, id: $id}) {
      clientMutationId
    }
  }
`
export const COMPLETE_EDIT_ORDER = gql`
  mutation completeOrderEdit($orderEdit: CompleteEditOrderInput!) {
    completeEditOrder(input: $orderEdit) {
      errors
      status
    }
  }
`

export const COMPLETE_EDIT_ORDER_BY_SHIPPING = gql`
  mutation CompleteEditOrderByShipping($orderEdit: CompleteEditOrderInput!) {
    completeEditOrderByShipping(input: $orderEdit) {
      errors
      status
    }
  }
`

export const COMPLETE_EDIT_ORDER_BY_PICKUP = gql`
  mutation completeEditOrderByPickup($orderEdit: CompleteEditOrderInput!) {
    completeEditOrderByPickup(input: $orderEdit) {
      errors
      status
    }
  }
`

export const COMPLETE_ORDER_REFUND = gql`
  mutation completeOrderPartialRefund($orderEdit: CompleteOrderRefundInput!) {
    completeOrderPartialRefund(input: $orderEdit) {
      errors
      status
    }
  }
`

export const COMPLETE_CASH_ORDER_REFUND = gql`
  mutation CompleteCashOrderPartialRefund($orderEdit: CompleteOrderRefundInput!) {
    completeCashOrderPartialRefund(input: $orderEdit) {
      errors
      status
    }
  }
`

export const UPDATE_EDIT_ORDER_NOTES = gql`
  mutation UpdateOrderEditNotes($orderEditId: UUID!, $note: JSON!) {
    updateOrderEditNotes(input: {pEditOrderId: $orderEditId, pNotes: $note}) {
      clientMutationId
      notes: json
    }
  }
`

export const GET_PROMO_DISCOUNTS_LIST = gql`
  query DiscountCodes {
    getPromoCodeDiscounts(filter: {status: {equalTo: ACTIVE}}) {
      nodes {
        id
        code
        discountRule {
          maximumAmount
          discountValue
          valueType
          discountType
        }
      }
    }
  }
`

export const UPDATE_ORDER_EDIT_PATCH = gql`
  mutation UpdateOrderEdit($id: UUID!, $patch: OrderEditPatch!) {
    updateOrderEdit(input: {patch: $patch, id: $id}) {
      clientMutationId
    }
  }
`

export const VALIDATE_DISCOUNT_CODE = gql`
  mutation ValidateDiscountCode($discount: ValidateDiscountCodeInput!) {
    validateDiscountCode(input: $discount) {
      errors
      status
      discountAmount
    }
  }
`
export const CHANGE_ORDER_STATUS = gql`
  mutation ChangeOrderStatus($notes: String!, $orderId: UUID!, $status: FulfillmentStatusTypes!) {
    changeOrderStatus(input: {pNotes: $notes, pOrderId: $orderId, pStatus: $status}) {
      clientMutationId
    }
  }
`

//Terminal Order partial return
export const GET_POS_REFUND_DISCOUNTS_LIST = gql`
  query PosRefundOrder($orderEdit: OrderRefundInput!) {
    posRefundOrder(input: $orderEdit) {
      transactionId
      metaData
      orderNumber
      paymentReferenceId
      totalAmount
      paymentType
    }
  }
`

export const COMPLETE_POS_TERMINAL_ORDER_REFUND = gql`
  mutation CompletePosTerminalOrderPartialRefund($model: CompletePosTerminalOrderRefundInput!) {
    completePosTerminalOrderPartialRefund(input: $model) {
      errors
      status
    }
  }
`

export const COMPLETE_COMPLIANCE_POS_TERMINAL_ORDER_REFUND = gql`
  mutation CompleteCompliancePosTerminalOrderRefund($order: CompleteComplianceOrderRefundInput!) {
    completeCompliancePosTerminalOrderRefund(input: {order: $order}) {
      errors
      status
    }
  }
`

export const GET_ORDER_TRANSACTIONS = gql`
  query GetOrderTransaction($orderId: UUID!) {
    getOrderTransactions(pOrderId: $orderId) {
      nodes {
        paymentType
        cardType
        paymentReferenceId
        amount
        metaData
      }
    }
  }
`

export const RESET_ORDER_REFUND_EDIT = gql`
  mutation ResetOrderRefundEdit($id: UUID!) {
    resetOrderRefundEdit(input: {pEditOrderId: $id}) {
      orderEdits {
        orderItems: orderEditItems {
          nodes {
            id
            price
            quantity
            orderEditId
            variantId
            orderItemId
            salesTax
            variant {
              available
              id
              name
              price
              discountPrice
              weight {
                value
                units
              }
              product {
                id
                name
                imageSrc
              }
            }
          }
        }
        discounts: appliedDiscounts {
          nodes {
            id
            amount
            code
            isPromoCode
            discountCodeId
            isShipping
            isWineClub
            name
            customDiscountPercentage
          }
        }
      }
    }
  }
`

export const UPDATE_EDIT_ORDER_TAX_AND_DISCOUNT_REMOVED = gql`
  mutation UpdateOrderEdit($order: OrderEditPatch!, $id: UUID!) {
    updateOrderEdit(input: {patch: $order, id: $id}) {
      clientMutationId
    }
  }
`

export const DELETE_ORDER_EDIT_ITEM = gql`
  mutation DeleteOrderEditItem($id: UUID!) {
    deleteOrderEditItem(input: {id: $id}) {
      clientMutationId
    }
  }
`

export const ORDER_ADDRESS_PROFILE_UPDATE = gql`
  mutation OrderAddressProfileUpdate($id: UUID!) {
    orderAddressProfileUpdate(input: {pOrderId: $id}) {
      clientMutationId
    }
  }
`
